export const errorMapping = {
  PAYMENT_METHOD_NOT_EXISTS: 'adminSets:errors.paymentMethodNotExists',
  SET_CARDS_NOT_ACTIVATED: 'adminSets:errors.setCardsNotActivated',
  SET_LOOTS_NOT_EXISTS: 'adminSets:errors.setLootNotExists',
  SET_RARITIES_NOT_EXISTS: 'adminSets:errors.setRaritiesNotExists',
  TWITCH_USER_NOT_EXISTS: 'adminSets:errors:twitchUserNotExists',
};
